// Module
var code = `<div class="toggle-container"> <div class="range-field" style="width:60px"> <input type="range" name="points" (change)="loadSelectionChange()" [min]="1" class="" max="3" [(ngModel)]="this._selectedItem" [ngClass]="this.selectedClassName"> </div> </div> `;
// Exports
export default code;